import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import { Box } from "@mui/material";
import ModuleTile from "../../../components/module-button/module-button";
import Typography from "../../../components/typography/typography";
import FullScreenLayout from "../../../layout/fullScreen/fullScreen";
import { useEffect, useMemo, useState } from "react";
import modules from "../../../constants/modules";
import images from "../../../assets/images";
import "./dashboard.scss";
import { getToken } from "../../../utils/common";
import { getV1RoleUserId } from "../../../api-client/api.rbac/api";

export const Dashboard = () => {
  const { t } = useTranslation();
  const [erp_modules, setModules] = useState<any | undefined>([]);

  const u_data = localStorage.getItem("_u_data") || undefined;
  const userData = useMemo(() => (u_data ? JSON.parse(u_data) : ""), [u_data]);

  const access_modules = userData?.module_access && userData?.module_access?.length > 0 ? userData?.module_access : [{ "module_name": "user" }]
  const display_modules = erp_modules?.filter((item1: any) => access_modules?.some((item2: any) => item2.module_name == item1.beModuleName || item1.beModuleName === "rbac"));
  const rolePermission = localStorage.getItem("role-permission") || undefined;

  const permissions = rolePermission && JSON.parse(rolePermission)?.modules ? JSON.parse(rolePermission).modules : [];
  let matchedModules = display_modules
  if (permissions.length) {
    matchedModules = display_modules.filter(module => permissions.includes(module.beModuleName));
  }

  useEffect(() => {
    setModules(modules(t));
  }, [t]);

  const getAndSetUserRoleAndPermissions = async (userId) => {
    const response = await getV1RoleUserId({
			id: userId,
			...getToken(),
		} as any);
		const data = response?.data.role;
    localStorage.setItem('role-permission', JSON.stringify(data));
  }

  useEffect(() => {
    if (userData?.id) {
      getAndSetUserRoleAndPermissions(userData.id);    }
  }, [userData?.id]);

  return (
    <Box>
      <CssBaseline />
      <FullScreenLayout>
        <Box className="dashboard-container">
          <Box className="dashboard-heading">
            <Typography type="h2" className="dashboard-title">
              {t("dashboard.title")}
            </Typography>
            <Typography type="s3" className="dashboard-subtitle">
              {t("dashboard.subtitle")}
            </Typography>
          </Box>
          <Box className="module-container">
            {matchedModules?.map((module: any, index: number) => {
              return <ModuleTile module={module} key={index} />;
            })}
            {
              userData && userData?.role_name == "Admin" && 
                <ModuleTile
                  module={{
                    label: "Add New Module",
                    link: "",
                    sidebar: images.addModule,
                    icon: images.addModule,
                    permission: "",
                    bg: "transparent",
                  }}
                  key={0}
                />
            }
            
          </Box>
        </Box>
      </FullScreenLayout>
    </Box>
  );
};

export default Dashboard;
